export default "__VITE_ASSET__DNxDy3X9__"